/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable radix */
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import axios from 'axios'
import { useLocation, useParams } from 'react-router-dom'
import { UseFormatador } from '../FormatadorCpfCnpj'
import { getTabelaVendas } from '../../services/TabelaVendas/getTabelaVendas'

export const useTabelaVendas = () => {
  const { id } = useParams()
  const location = useLocation()
  const { pathname } = location
  const pathnameArray = pathname.split('/')
  const { formatarCPF } = UseFormatador()
  const [isLoading, setIsLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [sales, setSales] = useState<GetSalesType>({} as GetSalesType)
  const [showTabelaVendas, setShowTabelaVendas] = useState(false)

  let tela = ''
  if (pathnameArray.includes('produtos') || pathnameArray.includes('produto')) {
    tela = 'produto'
  } else if (pathnameArray.includes('vendedores')) {
    tela = 'vendedor'
  } else if (pathnameArray.includes('empresas')) {
    tela = 'empresa'
  }

  const fetchTabelaVenda = async (cancel?: any) => {
    setIsLoading(true)
    const result = await getTabelaVendas(
      cancel,
      parseInt(id!),
      tela,
      currentPage
    )
    setIsLoading(false)
    if ('message' in result) {
      if (result.message === 'cancelToken') {
        ;('')
      } else {
        toast.error(result.message)
      }
    } else {
      setSales(result)
    }
  }

  const handleShowTabelaVendas = () => {
    setShowTabelaVendas(!showTabelaVendas)
  }

  useEffect(() => {
    const source = axios.CancelToken.source()
    fetchTabelaVenda(source)
    return () => {
      source.cancel('cancelToken')
    }
  }, [currentPage])

  return {
    currentPage,
    setCurrentPage,
    sales,
    isLoading,
    formatarCPF,
    showTabelaVendas,
    handleShowTabelaVendas,
  }
}
